export enum TecnologyProviderEnums{
  ninguno = 1,
  cervino = 2,
  carvajal = 3,
  theFactory = 4,
  factible = 5
}